// @flow
import * as types from "../ACTIONS/actionTypes";
import commonInitialState from "../GUI_COMMON/REDUCERS/commonInitialState";
import {convertJsonProfilesToProfileObjects} from "../GUI_COMMON/REDUCERS/profilesReducer";
import type Profile from "../GUI_COMMON/SUPPORT/Profile";
export default function profilesReducer(state = commonInitialState.profiles, action) {

    switch (action.type) {

        // GOT_PROFILE_LIST - moved to commonReducer
        case types.ADD_NEW_PROFILE: {
            const newProfile:Profile = convertJsonProfilesToProfileObjects([action.profile])[0]; // note the [0]
            const updatedProfiles = [...state.items, newProfile];
            updatedProfiles.sort((a, b) => a.name.localeCompare(b.name));
            return {
                initialized: true,
                items: updatedProfiles
            };
        }
        case types.REMOVE_PROFILE: {
            const updatedProfiles: Profile[] = state.items.filter(p => p.id !== action.profileId);
            return {
                initialized: true,
                items: updatedProfiles
            };
        }
        case types.UPDATE_PROFILE: {
            const updatedProfiles: Profile[] = state.items.filter(p => p.id !== action.profile.id);
            const updatedProfile = convertJsonProfilesToProfileObjects([action.profile])[0]; // note the [0]
            updatedProfiles.push(updatedProfile); // read add.
            updatedProfiles.sort((a, b) => a.name.localeCompare(b.name));
            return {
                initialized: true,
                items: updatedProfiles
            };
        }
        case types.REMOVE_IR_FROM_PROFILE: {
            const profileId = Number(action.profileId);
            const parentProfile: Profile = state.items.find(p => p.id===profileId);
            // kill the removed IR from the list
            parentProfile.inspectionRegions = parentProfile.inspectionRegions.filter(ir => ir.id !== action.irId);
            const updatedProfiles:Profile[] = state.items.filter(p => p.id !== profileId);
            updatedProfiles.push(parentProfile);
            
            return {
                initialized: true,
                items: updatedProfiles
            };
        }
            
        default:
            return state;
    }
}
    